var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-main",staticStyle:{"font-size":"16px"}},[_c('index-header'),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('wap-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }